import { logPageImpression } from '../analytics/analytics'
import { logGoogleAnalyticsEvent } from '../analytics/google-analytics'
import updateAddressBar from '../ux/address-bar'

/* global $, SDM_head, googletag */

let $form = null
let pauseAjaxUpdates = false

document.addEventListener("DOMContentLoaded", () => {
  initElementsFromPage()
  initDynamicFilterSubmit()
  submitSubscribeFormFromCTAButton();
});

function initElementsFromPage () {
  $form = $('.js__categoryFilterSelectForm');
  initResetAllFilters();
  initResetSingleFilter();
}

/**
 * Fetch new results and update everything inside the fetched view
 *
 * @param {*} dataParam
 * @param {*} updatedURL
 */
function fetchFilteredResults(dataParam, updatedURL) {
  $.get({
    url: window.location.pathname,
    data: dataParam,
    success: function (data) {
      $('.js__categoryUpdateWrapper').html(data)
      // initLazyLoad()
      updateAddressBar(updatedURL)
    },
    beforeSend: function () {
      showLoadingIndicator()
    },
    complete: function () {
      hideLoadingIndicator()
      logPageImpression()
      logGoogleAnalyticsEvent('bikemarkt', 'category', 'apply filter')
      refreshAds()
      initElementsFromPage()
      //initInfiniteScrolling()
      submitSubscribeFormFromCTAButton();
    }
  })
}

/**
 * Init & watch 'reset all filters' button
 *
 * @returns void
 */
function initResetAllFilters () {
  const resetAllButton = document.querySelector('.js__resetAllFilters');

  if (!resetAllButton) {
    return;
  }

  resetAllButton.addEventListener('click', () => {
    fetchFilteredResults(null, window.location.pathname);
  });
}

/**
 * Init and watch clicks on reset single filter buttons and dispatch change
 * event or click inside the form to update the visible inputs - change is
 * watched by initDynamicFilterSubmit()
 *
 * @returns void
 */
function initResetSingleFilter () {
  const resetFilters = document.querySelectorAll('.js__resetFilter');

  if (!resetFilters) {
    return;
  }

  const filterForm = document.querySelector('.js__categoryFilterSelectForm');
  const filterFormData = new FormData(filterForm);

  resetFilters.forEach((resetFilter) => {

    resetFilter.addEventListener('click', (e) => {
      const chosenFilterName = resetFilter.dataset.filter;
      const chosenFilterValue = resetFilter.dataset.value;

      let formInput = false;

      if (filterFormData.has(`${chosenFilterName}[]`)) {
        formInput = filterForm.querySelector(`[name="${chosenFilterName}[]"][value="${chosenFilterValue}"]`);
      } else if (filterFormData.has(chosenFilterName)) {
        formInput = filterForm.querySelector(`[name="${chosenFilterName}"]`);
      }

      if (!formInput) {
        // Somehow the value is not found (ie form updated, filter removed, old/manipulated url)
        // @TODO maybe log this case somewhere for further inspection?
        return;
      }

      if (formInput.type === 'radio' || formInput.type === 'checkbox') {
        formInput.click();
      } else if (formInput.type === 'select-one') {
        formInput[0].selected = 'selected';
        formInput.dispatchEvent(new Event('change'));
      } else {
        formInput.value = '';

        formInput.dispatchEvent(new Event('change'));
      }
    });
  });
}

function initDynamicFilterSubmit () {
  let $radioButtons = $('input[type=radio]', $form)
  let $checkboxes = $('input[type=checkbox]', $form)
  let $fields = $('input[type=text]', $form)
  let $selects = $('select', $form)

  $radioButtons.on('click', ajaxSubmitCategoryFilter)
  $checkboxes.on('click', ajaxSubmitCategoryFilter)
  $fields.on('change', ajaxSubmitCategoryFilter)
  $selects.on('change', ajaxSubmitCategoryFilter)
}

function ajaxSubmitCategoryFilter () {
  lockHeaderBannerHeight()

  let filterParams = $form.serialize()

  if (pauseAjaxUpdates) {
    return
  }

  fetchFilteredResults(filterParams, getUrlFromParams(filterParams));
}

function convertToHiddenField ($field) {
  return $('<input>')
    .attr('type', 'hidden')
    .attr('name', $field.attr('name'))
    .val($field.val())
}

function getUrlFromParams (params) {
  return window.document.location.pathname + '?' + params
}

function showLoadingIndicator () {
  $('.js__categoryUpdateWrapper').css('opacity', '0.5')
}

function hideLoadingIndicator () {
  $('.js__categoryUpdateWrapper').css('opacity', '1.0')
}

function refreshAds () {
  if (typeof SDM_head !== 'undefined') { // eslint-disable-line
    SDM_head.refreshAllAds()
    return
  }

  if (typeof googletag.pubads !== 'undefined') {
    googletag.pubads().refresh()
  }
}

function lockHeaderBannerHeight () {
  $('.header__banner').addClass('header__banner--heightlock')
}

/**
 * Submit the subscribe-form from the CTA button on top of the page
 */
function submitSubscribeFormFromCTAButton () {
  const ctaSubscribeButton = document.querySelector('.js__submitSubscribeForm');
  const subscribeForm = document.querySelector('.js__submitSubscribeToCategoryForm');

  if (!ctaSubscribeButton || !subscribeForm) {
    return;
  }

  ctaSubscribeButton.addEventListener('click', () => {
    document.querySelector('.js__submitSubscribeToCategoryForm').click();
  });
}
